// @core/api/endpoints/audittrail/list_data_subject_access_requests.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDataSubjectAccessRequestsResponse,
} from '../../../types/audittrail';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/audittrail';

/**
 * List data subject access requests
 * Returns all DSARs. Supports filtering by status, request type, and date range.
 */
export async function ListDataSubjectAccessRequests(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDataSubjectAccessRequestsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/dsar`;
  const requestOptions = options;
  return client.get<ListDataSubjectAccessRequestsResponse>(requestPath, { ...requestOptions, params });
}
